import { render } from "./CustomerService.vue?vue&type=template&id=cecb784e&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"

import "./CustomerService.vue?vue&type=style&index=0&id=cecb784e&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cecb784e"]])

export default __exports__